export const SHARE_DESTINATIONS = {
    FACEBOOK: 'facebook',
    LINKED_IN: 'linkedin',
    CLICKED_LINK: 'link',
};
